module.exports = __webpack_public_path__ + "img/redbookpicture.d7e50025.png";